import React from "react";
import styled from "styled-components";
import { Device } from "../../../../components/device";

export type DrawerPlacement = "left" | "right" | "top" | "bottom";
export type DrawerType = "full" | "login";

/*
TO DO:
- Touch slide close
*/

interface DrawerProps
{
    placement: DrawerPlacement;
    close?: () => void;
    visible?: boolean;
    styleType?: DrawerType;
    zIndex?: number;
}

const DrawerWrap = styled.div<DrawerProps>`
    background-color: ${props => props.styleType === "full" ? "rgba(255,255,255,.5)" : "white"};
    color: black;
    position: fixed;
    box-shadow: ${props => props.visible ? "0px 8px 10px -5px rgba(0,0,0,0.2), 0px 16px 24px 2px rgba(0,0,0,0.14), 0px 6px 30px 5px rgba(0,0,0,0.12);" : "none" };
    height: 100%;
    width: ${props => (props.placement === "top") || (props.placement === "bottom") ? "100%" : "33.33vw" };
    padding: 0;
    z-index: ${props => props.visible ? props.zIndex : "-1" };
    left: ${props => (props.placement === "right") ? "auto" : "0"};
    right: ${props => (props.placement === "left") ? "auto" : "0"};
    top: ${props => (props.placement === "bottom") ? "auto" : "0"};
    bottom: ${props => (props.placement === "top") ? "auto" : "0"};
    visibility: ${props => props.visible ? "visible" : "hidden" };
    will-change: transform;
    transform: ${props =>
        (props.placement === "left" && !props.visible) ? "translateX(-100%)" :
            (props.placement === "right" && !props.visible) ? "translateX(100%)" :
                (props.placement === "top" && !props.visible) ? "translateY(-100%)" :
                    (props.placement === "bottom" && !props.visible) ? "translateY(100%)" :
                        "translate(0)" };
    transition: ${props => (props.visible) ? "all 0.20s ease-out" : "none" };

    ${Device.mobileMax} {
        width: 100%;
        z-index: ${props => (props.styleType === "login") ? "999" : props.zIndex }
    }

    &.full{
        background-color: transparent;
    }

    .drawer__header,
    .drawer__footer {
        border: none;
        color: currentColor;
        cursor: pointer;
        display: flex;
        font-size: 1rem;
        font-weight: bold;
        letter-spacing: .075rem;
        align-items: center;
        justify-content: center;
        width: 100%;
        padding: .75rem 1rem;
        position: relative;
        overflow: hidden;
        user-select: none;
        text-transform: uppercase;
        text-decoration: none;
        h5 {
            margin-bottom: 0;
        }
        &:focus {
            outline: none;
        }
    }

    .drawer__header {
        height: var(--app-bar-height, 60px);
        &-btn-right {
            position: absolute;
            right: 1rem;
        }
    }

    .drawer__main {
        height: 100vh;
        overflow: hidden;
        overflow-y: auto;
        padding: 1rem;
        &--minus-header-footer {
            height: calc(100vh - 275px);
        }
        &-ul {
            list-style: none;
        }
        &-li {
            border: none;
            border-bottom: 1px solid var(--color-gray-30, currentColor);
            display: list-item;
        }
    }

    .drawer__footer {
        height: 90px;
        background-color: white;
        border-top: 1px solid var(--color-gray-10, #f4f4f4);
        position: absolute;
        bottom: 0;
        &-btn {
            width: 100%;
            margin: 0;
            display: flex;
            align-items: center;
            justify-content: space-between;
        }
        &-icon-left,
        &-icon-right {
            pointer-events: none;
        }
    }

`;

const Drawer: React.FC<DrawerProps> = (props) => (
    <DrawerWrap {...props}>
        {props.children}
    </DrawerWrap>
);

export default Drawer;
